import React, { Component } from 'react'
import { connect } from 'react-redux'

import SidebarBuildingLocation from '../components/common/SidebarBuildingLocation'
import { SimpleSpinner } from '../components/common/SimpleSpinner'
import backgroundImg from '../images/background.jpg'
import { loadLocationStart } from '../redux/modules/location'
import { selectCurrentLocationWithAddress } from '../redux/modules/selectors'
import { pushGTMUserInfo } from '../util/gtmUtils'

const FOODSBY_BASE_URL = process.env.REACT_APP_FOODSBY_BASE_URL

export class SimpleLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: false,
      loaded: false,
      multipleLocations: false,
    }
  }

  componentDidMount() {
    pushGTMUserInfo()
  }

  componentDidUpdate(prevProps) {
    const { locationSearch } = this.props

    let foundLocations = locationSearch.locations.foundLocations
    let { error, loaded, multipleLocations } = this.state

    if (!prevProps.currentUser && this.props.currentUser) {
      this.props.loadProfileStart()
    }
    if (foundLocations != null) {
      // if search returned any locations
      if (!loaded && foundLocations.length > 1) {
        // if search returned multiple locations
        this.setState({ error: false, loaded: true, multipleLocations: true })
      } else if (error && loaded && foundLocations.length > 1) {
        // if there was an error previously and new search returned multiple locations
        this.setState({ error: false, loaded: true, multipleLocations: true })
      } else if (!loaded && foundLocations.length === 0) {
        // if search returned no valid locations
        this.setState({ error: true, loaded: true })
      } else if (multipleLocations && foundLocations.length === 0) {
        // if multiple locations were found and new search returns no valid locations
        this.setState({ error: true, multipleLocations: false })
      }
    }
  }

  render() {
    const { children, completeAccountToken, loading, location } = this.props

    return (
      <div className="main simple-layout">
        <header className="header header-large">
          <div
            className="header-inner"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              margin: '0 16px',
              maxWidth: '100%',
              padding: '8px',
            }}
          >
            <a
              className="header-logo"
              href={`${FOODSBY_BASE_URL}/main/`}
              rel="noopener noreferrer"
              style={{ marginLeft: '3px' }}
              target="_blank"
            >
              <div className="foodsby-logo" />
            </a>
            <div>
              {location ? (
                <div
                  className="confirmAcctAddress"
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <SidebarBuildingLocation
                    completeAccountToken={completeAccountToken}
                    location={location}
                    multipleLocations={this.state.multipleLocations}
                    showError={this.state.error}
                  />
                </div>
              ) : (
                loading && <SimpleSpinner />
              )}
            </div>
          </div>
        </header>
        <article
          className="content simpleContent"
          id="content"
          style={{
            backgroundImage: `url(${backgroundImg})`,
            marginTop: backgroundImg ? '0' : '0',
          }}
        >
          {children}
        </article>
        <div className="simple-footer-wrapper">
          <div className="row middle-xs">
            <div className="col-xs-12">
              <div className="simple-footer-text">
                $1.99 Delivery <span className="primary simple-footer-bullet">●</span> No Tipping{' '}
                <span className="primary simple-footer-bullet">●</span> No Minimums{' '}
                <span className="primary simple-footer-bullet">●</span> No Hidden Fees{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const location = selectCurrentLocationWithAddress(state)
  const locationSearch = state.locationSearch
  let completeAccountToken

  if (window.location.pathname.includes('/complete-account/')) {
    completeAccountToken = window.location.pathname.split('/complete-account/')[1]
  }

  return {
    completeAccountToken,
    location,
    locationSearch,
  }
}

const mapDispatchToProps = {
  loadLocationStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(SimpleLayout)
